/**
 * Created by Ding on 13/07/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Input, Upload, Form, Button, message, Modal, Select, Progress, Checkbox } from 'antd';

import { phoneRegexCN, phoneRegexOther, emailRegex } from '../../utils/common';
import { ajaxGet, ajaxPost } from '../../utils/ajax';
import Authorization from '../../components/Authorization';
import './index.less'

const FormItem = Form.Item;
const Option = Select.Option;
let isShowWarning = true;
const TextArea = Input.TextArea;
const AREA_PHONE_API = {
    GET_PHONE_AREA: ' /recruit/api/hunter/getPhoneAreaCode',
};

class RecommendCandidateForm extends Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        handleUploadSucceed: PropTypes.func.isRequired,
    };

    state = {
        resumeStatus: 'error',
        submitting: false,
        isPhoneDirty: false,
        loading: false,
        progressShow: false, // 解析进度
        progressPercent: 0, // 进度条百分比
        isFinish: false, // 是否解析完成
        isClickDel: false, // 是否点击了删除
        checkbox: false,
        visible: false,
        isSearch: false, // 是否搜索
    };

    componentDidMount() {
        this.getPhoneArea();
    }

    getPhoneArea = () => {
        ajaxGet(AREA_PHONE_API.GET_PHONE_AREA, {}, (data) => {
            data && data.data && this.setState({
                countryCode: data.data,
            });
        });
    }
    onSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (!this.state.checkbox) {
                    message.warning('请阅读并勾选个人信息处理授权书');
                    return;
                }
                values.phoneCode = values.phoneCode.replace(/[^0-9]/ig, '');
                const hunterName = values.name || '';

                if ((hunterName.indexOf('先生') > -1 || hunterName.indexOf('女士') > -1) && isShowWarning) {
                    Modal.warning({
                        title: '注意',
                        content: '请确定候选人姓名为真实姓名，否则会造成无法支付费用！',
                        onOk: () => {
                            isShowWarning = false;
                        },
                        okText: '确定',
                    });

                    return;
                }

                this.setState({
                    submitting: true,
                });

                this.props.handleSubmit(Object.assign({}, values, {}), () => {
                    this.setState({
                        submitting: false,
                    });
                }, (data) => {
                    message.error(data.meta.message);
                    this.setState({
                        submitting: false,
                    });
                });
            }
        });
    };

    onPhoneBlur = (e) => {
        const value = e.target.value;
        this.setState({
            isPhoneDirty: this.state.isPhoneDirty || !!value,
        });
    };

    nameChange = () => {
        isShowWarning = true;
    };

    validateResume = (rule, value, callback) => {
        setTimeout(() => {
            if (this.state.resumeStatus === 'error') {
                callback('请上传简历');
            } else if (this.state.resumeStatus === 'success') {
                callback();
            }
        }, 1000);
    };

    phoneValidator = (rule, value, callback) => {
        const phoneCode = this.props.form.getFieldValue('phoneCode');
        if (value) {
            if (
                (phoneCode === '86' || phoneCode === '中国大陆86') &&
                !phoneRegexCN.test(value)
            ) {
                callback('手机格式不正确');
            } else if (
                (phoneCode !== '86' || phoneCode !== '中国大陆86') &&
                !phoneRegexOther.test(value)
            ) {
                callback('手机格式不正确');
            } else {
                callback();
            }
        } else {
            callback();
        }
    };

    checkPhone = (rule, value, callback) => {
        if (this.state.isPhoneDirty) {
            this.props.form.validateFields(['phone'], { force: true });
        }
        callback();
    };

    removeResume = () => {
        const { setFieldsValue } = this.props.form;
        if(!this.state.isFinish) { // 如果不是在解析完成后点的删除按钮
            this.setState({
              progressShow: false,
              isClickDel: true
            })
        } else {
            this.setState({
              progressShow: false,
              isClickDel: false
            })
        }
        setFieldsValue({ resume: undefined });
        this.setState({
            resumeStatus: 'error',
            progressShow: false
        });
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldsValue } = this.props.form;
        const formItemLayout = {
            labelCol: {
                sm: { span: 3 },
            },
            wrapperCol: {
                sm: { span: 9 },
            },
        };
        const formItemTextAreaLayout = {
            labelCol: {
                sm: { span: 3 },
            },
            wrapperCol: {
                sm: { span: 21 },
            },
        };
        const formItemUploadLayout = {
            labelCol: {
                sm: { span: 3 },
            },
            wrapperCol: {
                sm: { span: 11 },
            },
        };
        const uploadProps = {
            name: 'resumeToUpload',
            multiple: false,
            accept: '.pdf,.doc,.docx,.txt,.rtf,.png,.jpg',
            action: '/api/resume/upload',
            disabled: this.state.resumeStatus !== 'error',
            beforeUpload: (file) => {
                if (!['pdf', 'doc', 'docx', 'png', 'jpg', 'txt', 'rtf']
                    .includes(file.name.split('.')
                        .slice(-1)[0].toLowerCase())) {
                    message.warn('您上传的文件格式不正确，请重新选择');
                    return false;
                }
                if (file.size / 1024 / 1024 > 10) {
                    message.warn(`${file.name}大于10M，不允许上传!`);
                    return false;
                }
                this.setState({
                    progressPercent: 0,
                    isFinish: false,
                    isClickDel: false
                });
                return true;
            },
            onChange: (info) => {
                if (info.file.status !== 'removed') {
                    this.setState({
                        resumeStatus: 'validation',
                    });
                }
                if (info.file.status === 'done') {
                    const { response } = info.file;
                    this.setState({
                        progressPercent: 50,
                    });
                    if (response && response.meta && response.meta.code === 0) {
                        // message.success(`${info.file.name} 上传成功`);
                        this.setState({
                            resumeStatus: 'success',
                        });
                        const newParams = {
                            fileName: info.file.name,
                            uri: info.file.response.data,
                            channelId: 300,
                        };
                        ajaxPost('/recruit/api/common/parse', newParams, ({ data }) => {
                            if (data.errorNo !== 0) {
                                this.setState({
                                    progressShow: false,
                                    isFinish: true,
                                });
                                message.error(data.errorInfo);
                                this.props.handleUploadSucceed({
                                    submittable: true,
                                });
                            } else {
                                this.setState({
                                    progressPercent: 100,
                                    progressShow: false,
                                    isFinish: true,
                                });
                                console.log(this.state.isClickDel,'this.state.isClickDel')
                                if(this.state.isClickDel) { // 如果不是在解析完成后点的删除，则直接return
                                    return false;
                                }
                                const {name, email, phone} = this.props.form.getFieldsValue();
                                const ifExistVal = name || email || phone;
                                if(ifExistVal) {
                                    Modal.confirm({
                                      content: '是否根据本次上传的简历，覆盖候选人姓名、手机和邮箱输入信息？',
                                      okText: '是，覆盖',
                                      cancelText: '否，不覆盖',
                                      iconType: 'exclamation-circle',
                                      className: 'confirm-update-pop',
                                      width: '400px',
                                      onOk: () => {
                                        setFieldsValue({
                                            name: data.name,
                                            email: data.email,
                                            phone: data.phone,
                                        });
                                      }
                                    })
                                } else {
                                    setFieldsValue({
                                        name: data.name,
                                        email: data.email,
                                        phone: data.phone,
                                    });
                                }
                                this.props.handleUploadSucceed({
                                    parseResult: {
                                        ...data,
                                        fileName: info.file.name,
                                    },
                                    submittable: true,
                                });
                            }
                        }, ({ meta }) => {
                            message.error((meta && meta.message) || '网络请求失败，请稍后重试！');
                            this.setState({
                                progressShow: false
                            });
                            this.props.handleUploadSucceed({
                                submittable: false,
                            });
                        });
                    } else if (response.meta.code === 30001) {
                        window.location.href = '/login';
                    } else {
                        message.error(response.meta.message);
                        this.setState({
                            resumeStatus: 'error',
                            progressShow: false
                        });
                    }
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败.`);
                    this.setState({
                        resumeStatus: 'error',
                        progressShow: false
                    });
                } else if (info.file.status === 'uploading') {
                    this.setState({
                        progressShow: true
                    });
                }
            },
            onRemove: this.removeResume,
        };

        return (
            <div className='hunter-recommended-candidates'>
            <Form onSubmit={this.onSubmit}>
                <div className="panel">
                    <div style={{ width: '780px', maxWidth: '100%' }}>
                        <FormItem
                            {...formItemLayout}
                            label="候选人姓名:"
                            hasFeedback
                        >
                            {getFieldDecorator('name', {
                                rules: [
                                    { required: true, message: '请输入候选人姓名', whitespace: true },
                                ],
                                getValueFromEvent: (e) => {
                                    const val = e.target ? e.target.value : '';

                                    return val ? val.replace(/\s/g, '') : '';
                                },
                            })(<Input placeholder="请输入候选人真实姓名" onChange={this.nameChange} />)}
                        </FormItem>

                        <FormItem
                            label="候选人手机号"
                            {...formItemLayout}
                            hasFeedback
                            required
                        >
                            <FormItem
                                className="form-country-code"
                            >
                                {getFieldDecorator('phoneCode', {
                                    initialValue: '86',
                                    rules: [{ validator: this.checkPhone }],
                                })(
                                    // <Select>
                                    //     {countryCode.map(item => (
                                    //         <Option key={item.key} value={item.key}>{item.name}</Option>
                                    //     ))}
                                    // </Select>,
                                    <Select
                                        className={this.state.isSearch ? 'hunter-form-country-code-search' : this.props.phoneCodeStyle}
                                        optionLabelProp="phone"
                                        style={{
                                            width: '88px', height: '32px', lineHeight: '31', margin: '0',
                                        }}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ width: '220px' }}
                                        showSearch
                                        onBlur={()=>{
                                            this.setState({
                                                isSearch: false
                                            })
                                        }}
                                        onFocus={()=>{
                                            this.setState({
                                                isSearch: true
                                            })
                                        }}
                                    >
                                        {this.state.countryCode && this.state.countryCode.map(item => (
                                            <Option
                                                key={item.countryName + item.areaCode}
                                                phone={item.areaCode}
                                                value={item.countryName + item.areaCode}
                                            >
                                                 <span style={{width:'40px',display: 'inline-block'}}>{item.areaCode}</span>{item.countryName}
                                            </Option>
                                        ))}
                                        {/* {
                                            countryCode.map(item => (
                                                <Option key={item.key} value={item.key}>{item.name}</Option>
                                            ))
                                        } */}
                                    </Select>)}
                            </FormItem>
                            <FormItem
                                className="form-phone-number"
                                style={{ margin: '0' }}
                            >
                                {getFieldDecorator('phone', {
                                    rules: [
                                        { required: true, message: '请输入手机号', whitespace: true },
                                        { validator: this.phoneValidator },
                                    ],
                                    getValueFromEvent: (e) => {
                                        const val = e.target ? e.target.value : '';

                                        return val ? val.replace(/\s/g, '') : '';
                                    },
                                })(<Input
                                    type="tel"
                                    style={{ width: '200px' }}
                                    placeholder="请输入手机号"
                                    onBlur={this.onPhoneBlur}
                                />)}
                            </FormItem>
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="候选人邮箱:"
                            hasFeedback
                        >
                            {getFieldDecorator('email', {
                                rules: [
                                    { required: true, message: '请补充信息', whitespace: true },
                                    {
                                        pattern: emailRegex,
                                        message: '邮箱格式不正确！',
                                    },
                                ],
                            })(<Input placeholder="请输入候选人邮箱" />)}
                        </FormItem>

                        <FormItem
                            {...formItemUploadLayout}
                            label="简历附件:"
                            hasFeedback
                        >
                            {getFieldDecorator('resume', {
                                rules: [
                                    { required: true, message: '简历为必填项' },
                                    { validator: this.validateResume },
                                ],
                            })(<Upload {...uploadProps}>点击上传</Upload>)}
                            <span style={{ color: '#999', lineHeight: '32px' }}>（支持.pdf/.doc(x)/.jpg/.png/.rtf/.txt文件格式，大约10MB）</span>
                        </FormItem>

                        <FormItem
                            {...formItemTextAreaLayout}
                            label="推荐理由:"
                            hasFeedback
                        >
                            {getFieldDecorator('recommenderComment', {
                                rules: [{ required: false, message: '请输入推荐理由!' }],
                            })(<TextArea rows={4} placeholder="请输入推荐理由" maxLength="256" />)}
                        </FormItem>
                    </div>
                </div>

                <div style={{ textAlign: 'right' }}>
                    <div className="CheckboxConent">
                        <Checkbox value={this.state.checkbox} onChange={e => this.setState({ checkbox: e.target.checked })}>我已阅读并确认
                        </Checkbox>
                        <span role="button" onClick={() => this.setState({ visible: true })} tabIndex="0" className="CheckboxA">个人信息处理授权书</span>
                    </div>
                    <Button style={{ marginLeft: '16px' }} onClick={() => this.props.history.goBack()}>返回</Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginLeft: '20px' }}
                        loading={this.state.loading || this.state.submitting}
                    >
                        {this.state.loading ? '简历解析中' : '保存并关闭'}
                    </Button>
                </div>
                <Authorization
                    visible={this.state.visible}
                    know
                    share
                    isClose
                    handleCancel={() => {
                        this.setState({
                            visible: false,
                        });
                    }}
                    headers={{
                        'perm-app-id': 'APP201014001',
                        'perm-timestamp': '1637289828879',
                        'perm-signature': '2369c7c13424111bc639335e36cd6a59914ee0a8922',
                    }}
                    getUserData={{
                        url: '/recruit/api/hunter/perm/getLicenseAgreement',
                    }}
                />
            </Form>
            {/* 解析进度 */}
            {this.state.progressShow &&
                <div className='progress-modal'>
                    {/* 进度提示文案 */}
                    <p className='progress-title'>简历上传、解析中，请等待</p>
                    {/* 进度条展示 */}
                    <Progress
                    status="active"
                    showInfo={false}
                    percent={this.state.progressPercent}
                    strokeWidth={6}
                    />
                </div>
            }
            </div>
        );
    }
}

export default Form.create({})(RecommendCandidateForm);
